import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback, useEffect, useMemo } from 'react';
import { useLocalStorage } from '@shared/hooks/use-localstorage.ts';
import { useMobile } from '@shared/hooks/use-mobile.ts';
import { ActiveTabType } from '@shared/types/common';

const storage_key = 'programsListViewType';
type ProgramsListViewType = 'grid' | 'list';
export const useProgramsListViewType = ({ activeTab }: { activeTab?: ActiveTabType }) => {
  const { setItem, getItem } = useLocalStorage();

  const { isMobile } = useMobile();

  const { data: programsListViewTypeState, doSetStorageData: setProgramsListViewTypeState } =
    useSaveData<ProgramsListViewType>(storage_key);

  const setProgramsListViewType = useCallback(
    (type: ProgramsListViewType) => {
      setItem(storage_key, type);
      setProgramsListViewTypeState(type);
    },
    [setItem, setProgramsListViewTypeState]
  );

  useEffect(() => {
    if (!programsListViewTypeState) {
      setProgramsListViewType((getItem(storage_key) as ProgramsListViewType) || 'grid');
    }
  }, [getItem, programsListViewTypeState, setProgramsListViewType]);

  const programsListViewType = useMemo(() => {
    if (isMobile || activeTab !== 'all') {
      return 'list';
    } else return programsListViewTypeState;
  }, [programsListViewTypeState, isMobile, activeTab]);

  return {
    programsListViewType,
    isListView: programsListViewType === 'list',
    setProgramsListViewType,
  };
};
